import { BASE_S3_URL } from './constant';

export const LOGO_BIG = /* BASE_S3_URL  +*/ '/logo-big.png';
export const ZAKAT_LOGO = BASE_S3_URL + 'zakat-logo.png';
export const ZAKAT_LOGO_BIG = BASE_S3_URL + '/logo-big.png';
export const MOSQUE_BG = BASE_S3_URL + 'mosk.png';
export const MOSQUE_HEADER_BG = BASE_S3_URL + 'mosk-header-bg.png';
export const PRAYER = BASE_S3_URL + 'prayer.png';
export const LOGO_250x250 = BASE_S3_URL + 'logo-250x250.png';
export const LOGO_250x249 = BASE_S3_URL + 'logo-250x249.png';
export const ZAKAT_LOGO_250x250 = BASE_S3_URL + 'zakat-logo-250x250.png';
export const LOGO_OUR_MASJID_60x76 = BASE_S3_URL + 'logo-our-masjid-65x76.png';
export const LOGO_OUR_MASJID_FOOTER_442x228 = BASE_S3_URL + 'ourmasjid-footer-logos-442x228.png';
export const NOT_REGISTERED_WARNING = BASE_S3_URL + 'not-registered-warning.png';
export const RECEIVE_RECEIPT = BASE_S3_URL + 'receive-receipt.jpg';
export const QR_CODE_PAYNOW_FADED = BASE_S3_URL + 'paynow-qr-code-faded.png';
export const QR_DUMMY_SINGPASS = BASE_S3_URL + 'qr-dummy.png';
export const ARROW_BACK = BASE_S3_URL + 'arrow-back.svg';
export const TICK_GRAPHIC = /* BASE_S3_URL +*/  'images/tick-graphic.svg';
export const TICK_SUCCESS_GRAPHIC = BASE_S3_URL + 'tick-success-graphic.svg';
export const ICON_RECEIPT = BASE_S3_URL + 'receipt.svg';
export const ENROLE_MANUALLY = BASE_S3_URL + 'enrole-manually.svg';
export const AC_VERIFY_PENDING = /* BASE_S3_URL + */ 'images/ac-verify-pending.svg';
export const ICON_NOTE = BASE_S3_URL + 'note-icon.svg';
export const ICON_WANT_SIGN_IN = BASE_S3_URL + 'want-sign-in.svg';
export const MARK_EXCLAMATION = BASE_S3_URL + 'exclamation-mark.svg';
export const MARK_EXCLAMATION_17x17 = BASE_S3_URL + 'exclamation-mark-17x17.svg';
export const MARK_EXCLAMATION_GREY_17x17 = BASE_S3_URL + 'exclamation-mark-gray-17x17.svg';
export const CLOSE_DARK = BASE_S3_URL + 'close-dark.svg';
export const ICON_PLUS = BASE_S3_URL + 'plus.svg';
export const ICON_MINUS = BASE_S3_URL + 'minus.svg';
export const ICON_CIRCLE_MINUS = BASE_S3_URL + 'circle-minus.svg';
export const ICON_CLOSE_POPUP = BASE_S3_URL + 'popup-close.svg';
export const ICON_CALENDAR = BASE_S3_URL + 'calendar.svg';
export const ICON_BACK = BASE_S3_URL + 'icon-back.svg';
export const ICON_EDIT = BASE_S3_URL + 'icon-edit.svg';
export const ICON_USER_PROFILE_27x27 = BASE_S3_URL + 'icon-user-profile-27x27.svg';
export const ICON_USER_PROFILE_30x30 = BASE_S3_URL + 'icon-user-profile-30x30.svg';
export const ICON_USER_PROFILE_42x42 = BASE_S3_URL + 'icon-user-profile-42x42.svg';
export const DOT_OPTIONS = BASE_S3_URL + 'dot-options.svg';
export const CLOSE_RED = BASE_S3_URL + 'close-red.svg';
export const CLOSE_SUCCESS_LOGIN = BASE_S3_URL + 'login-success-close.svg';
export const TICK_CIRCLE_BIG = BASE_S3_URL + 'tick-circle-big.svg';
export const TICK_LOGIN_SUCCESS = BASE_S3_URL + 'tick-login-success.svg';
export const TICK_SUCCESS = BASE_S3_URL + 'tick-success.svg';
export const ICON_TOOLTIP = BASE_S3_URL + 'toooltip.svg';


/** CARD IMAGES - .PNG */
export const CARD_DEFAULT = BASE_S3_URL + 'cards/default-195x125.png';
export const CARD_AMERICAN = BASE_S3_URL + 'cards/american-express-195x125.png';
export const CARD_DINERS_CLUB = BASE_S3_URL + 'cards/diners-club-195x125.png';
export const CARD_JCB = BASE_S3_URL + 'cards/jcb-195x125.png';
export const CARD_MASTER_CARD = BASE_S3_URL + 'cards/master-card-195x125.png';
export const CARD_UNION_PAY = BASE_S3_URL + 'cards/union-pay-195x125.png';
export const CARD_VISA = BASE_S3_URL + 'cards/visa-195x125.png';
export const CARD_GOOGLE = BASE_S3_URL + 'cards/g-pay.png';
export const CARD_APPLE_PAY = BASE_S3_URL + 'cards/apple-pay.png';
export const CARD_ALIPAY = BASE_S3_URL + 'cards/alipay.png';
export const CARD_GRABPAY = BASE_S3_URL + 'cards/grab-pay.png';
export const CARD_PAYNOW = BASE_S3_URL + 'cards/pay-now.png';
export const CARD_CASH = BASE_S3_URL + 'cards/cash-195x125.png';
export const CARD_CHEQUE = BASE_S3_URL + 'cards/cheque-195x125.png';
export const CARD_NETS = BASE_S3_URL + 'cards/nets-195x125.png';

/** CARD IMAGES - .SVG */
export const CARD_GOOGLE_SVG = BASE_S3_URL + 'cards/g-pay.svg';
export const CARD_APPLE_PAY_SVG = BASE_S3_URL + 'cards/applepay.svg';
export const CARD_ALIPAY_SVG = BASE_S3_URL + 'cards/alipay.svg';
export const DOTS_VERTICAL_3 = BASE_S3_URL + 'cards/vertical-dots-3.svg';
export const DOTS_HORIZONTAL_3 = BASE_S3_URL + 'cards/horizontal-card-dots.svg';
export const CARD_ADD_GRAPHICS = BASE_S3_URL + 'cards/add-card-graphic.svg';

/** SOCIAL ICONS */
export const SOCIAL_ICON_FACEBOOK = BASE_S3_URL + 'social/share-feature-icons/facebook.png';
export const SOCIAL_ICON_INSTAGRAM = BASE_S3_URL + 'social/share-feature-icons/instagram.png';
export const SOCIAL_ICON_LINK = BASE_S3_URL + 'social/share-feature-icons/link.png';
export const SOCIAL_ICON_MAIL = BASE_S3_URL + 'social/share-feature-icons/mail.png';
export const SOCIAL_ICON_TWITTER = BASE_S3_URL + 'social/share-feature-icons/twitter.png';
export const SOCIAL_ICON_WHATSAPP = BASE_S3_URL + 'social/share-feature-icons/whatsapp.png';

export const ICON_GOOGLE_G = BASE_S3_URL + 'icon-google-g.svg';
export const ICON_FACEBOOK_F = BASE_S3_URL + 'icon-facebook-f.svg';

/** CONTACTS - .SVG */
export const CONTACT_ADDRESS = BASE_S3_URL + 'contact/address.svg';
export const CONTACT_EMAIL = BASE_S3_URL + 'contact/email.svg';
export const CONTACT_TEL = BASE_S3_URL + 'contact/tel.svg';
